import React from "react";
import axios from "axios";
import OutlinedInput from "@mui/material/OutlinedInput";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { apiCall_domain } from "../api";
import { makeStyles } from "@mui/styles";
let value = [];
let valueArrey = null;

const usePlaceholderStyles = makeStyles((theme) => ({
  placeholder: {
    color: "#959595",
  },
}));
const Placeholder = ({ children }) => {
  const classes = usePlaceholderStyles();
  return <div className={classes.placeholder}>{children}</div>;
};
class ServiceTRype extends React.Component {
  state = {
    userCarSelected: "",
    selected: [],
    selectDays: "روز",
    hours: [],
    selectHour: "ساعت",
    description: "",
    error: "",
    valuesOfMultiSelect: [],
    ccc: [],
  };
  AdduserCar = (e) => {
    this.setState({ userCarSelected: e.target.value });
  };
  componentDidMount() {
    if (localStorage.getItem("status")) {
      this.props.props.history.push({
        pathname: "/",
      });
    }
  }
  DaysChange = (e) => {
    this.setState({ selectDays: e.target.value });
    const selectedHour = JSON.parse(localStorage.getItem("mechanic_Days")).find(
      (hours) => hours.name.toString() === e.target.value
    );
    this.setState({ hours: selectedHour.hours });
  };
  selectHour = (e) => {
    this.setState({ selectHour: e.target.value });
  };
  description = (e) => {
    this.setState({ description: e.target.value });
  };
  bookMechanics = () => {
    // this.state.selected.map((item) => {
    //     value.push(item.value)
    // })
    // valueArrey = value
    // valueArrey.push(value)
    if (this.state.userCarSelected === "") {
      this.setState({
        error: " لطفا خودرو خود را انتخاب کنید",
        loading: false,
      });
    } else if (this.state.valuesOfMultiSelect.length === 0) {
      this.setState({
        error: "لطفا مشکل های خود را انتخاب کنید",
        loading: false,
      });
    } else if (
      this.state.selectDays === "روز" ||
      this.state.selectHour === "ساعت"
    ) {
      this.setState({
        error: "لطفا روز  و ساعت مورد نظر  خود را انتخحاب کنید",
        loading: false,
      });
    } else if (this.props.userId === null || this.props.depotId === null) {
      this.setState({
        error: "لطفا آدرس مورد نظر خود را انتخاب کنید",
        loading: false,
      });
    } else {
      const Data = {
        customer_car_id: parseInt(this.state.userCarSelected),
        problems: this.state.valuesOfMultiSelect,
        garage_id: parseInt(localStorage.getItem("garage_id")),
        day: this.state.selectDays,
        time: this.state.selectHour,
        address_id: this.props.userId
          ? parseInt(this.props.userId)
          : parseInt(this.props.depotId),
        type: this.props.index == "static" ? "static" : "dynamic",
        description: this.state.description,
      };
      const headers = {
        Authorization: localStorage.getItem("Api_key"),
        "content-type": "application/json",
      };

      axios
        .post(`${apiCall_domain}/customer/mechanics/book`, Data, {
          headers: headers,
        })
        .then((res) => {
          if (res.status === 200) {
            localStorage.setItem("status", 1);
          }
          this.props.props.history.push({
            pathname: "/multiVendor/myRequest",
          });
        });
    }
  };
  pushAddCar = () => {
    this.props.props.history.push({
      pathname: "/Search/addCars",
      BackToMulti: true,
    });
  };
  render() {
    const handleChange3 = (event) => {
      this.setState({ valuesOfMultiSelect: event.target.value });
    };
    const selected = (e) => {
      this.setState({ selected: e });
    };
    const removedSelected = (e) => {};
    return (
      <div className="ServiceTypeMinDivC">
        <h1 className="titleReservationCom">انتخاب سرویس</h1>
        <div className="addUserCarReserv">
          <Select
            value={this.state.userCarSelected}
            onChange={(e) => this.AdduserCar(e)}
            displayEmpty
          >
            <MenuItem
              value={this.state.userCarSelected}
              onClick={(e) => this.pushAddCar(e)}
            >
              {
                <em className="emSelect MenuItemMULTY  EmSelectAddCarMultiVendor">
                  افزودن خودرو
                </em>
              }
            </MenuItem>
            <MenuItem value={this.state.userCarSelected}>
              {<em className="emSelect MenuItemMULTY">خودرو های من</em>}
            </MenuItem>
            {this.props.usersCar.map((item) => (
              <MenuItem
                key={item.id}
                value={String(item.id)}
                className="MenuItemMULTY"
              >
                {`${item.name ? item.name : ""}`}
              </MenuItem>
            ))}
          </Select>
          <img src="/public/assets/icons/downArrowReserv.svg" alt="pic"/>
        </div>
        <h1 className="titleReservationCom">مشکل فنی</h1>
        <div className="addUserCarReserv">
          <div>
            <FormControl sx={{ m: 1, width: 300, mt: 3 }}>
              <Select
                multiple
                displayEmpty
                value={this.state.valuesOfMultiSelect}
                name={this.state.ccc}
                onChange={(e) => handleChange3(e)}
                input={<OutlinedInput />}
                renderValue={
                  this.state.valuesOfMultiSelect.length !== 0
                    ? undefined
                    : () => <Placeholder>قسمت ایرادی خودرو</Placeholder>
                }
                placeholder={"یخهزتهیبتخهسشت"}
                inputProps={{ "aria-label": "Without label" }}
              >
                {this.props.problems.map((item) => (
                  <MenuItem
                    key={item.id}
                    value={parseInt(item.id)}
                    name={item.name}
                  >{`${item.name}`}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
        </div>
        <h1 className="titleReservationCom">توضیحات</h1>
        <textarea
          placeholder="توضیحات بیشتر خود را اینجا بنویسید ..."
          className="textArea"
          onChange={(e) => this.description(e)}
        />
        <h1 className="titleReservationCom">زمان سرویس</h1>
        <div className="servicesTimeVendorCom">
          <Select
            value={this.state.selectDays}
            onChange={(e) => this.DaysChange(e)}
            displayEmpty
          >
            <MenuItem value={this.state.selectDays}>
              {<em className="emSelect MenuItemMULTY">روز</em>}
            </MenuItem>
            {JSON.parse(localStorage.getItem("mechanic_Days")).map((item) => (
              <MenuItem
                className="MenuItemMULTY"
                key={item.id}
                value={String(item.name)}
                name={item.name}
              >{`${item.name ? item.name : ""}`}</MenuItem>
            ))}
          </Select>
          <Select
            value={this.state.selectHour}
            onChange={(e) => this.selectHour(e)}
            displayEmpty
          >
            <MenuItem value={this.state.selectHour}>
              {<em className="emSelect MenuItemMULTY">ساعت</em>}
            </MenuItem>
            {this.state.hours.map((item) => (
              <MenuItem
                className="MenuItemMULTY"
                value={String(item)}
              >{`${item}`}</MenuItem>
            ))}
          </Select>
        </div>
        <div className="error">{this.state.error}</div>
        <div className="ReservationBtnFinal">
          <button onClick={() => this.bookMechanics()}>رزرو سرویس</button>
        </div>
      </div>
    );
  }
}
export default ServiceTRype;
